// AUTO-GENERATED from backend/sorrento_faq.py — do not edit by hand.
// Unique, non-templated SEO text + FAQ per Sorrento district (RU/EN).
export const sorrentoDistrictContent = {
  "centro": {
    "ru": {
      "seoText": "### Доставка цветов в центре Сорренто\n\nЦентр Сорренто живёт вокруг площади Пьяцца Тассо, откуда лучами расходятся Виа Сан Чезарео с лавками лимончелло и деревянной интарсии. Отсюда рукой подать до террас Вилла Комунале с видом на Неаполитанский залив и до причала Марина Пиккола, откуда уходят паромы на Капри.\n\nМы доставляем букеты в бутик-отели и рестораны старого города, к причалу и на смотровые террасы. Курьер знает лабиринт узких улочек центра, поэтому цветы приезжают свежими и вовремя — даже в разгар туристического сезона.\n\n**Что заказывают:** розы к ужину с видом на залив, букеты в номер Grand Hotel Excelsior Vittoria, сюрприз к парому на Капри.\n\n[Каталог букетов](/sorrento) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Доставите букет к ужину в ресторане на Пьяцца Тассо?",
          "a": "Да, привозим цветы прямо к столу или передаём метрдотелю к вашему приходу — популярно для годовщины и предложения в центре Сорренто."
        },
        {
          "q": "Можно оставить букет на ресепшене отеля в старом городе?",
          "a": "Конечно. В Grand Hotel Excelsior Vittoria, Antiche Mura и других отелях центра букет примет консьерж, а мы согласуем момент вручения."
        },
        {
          "q": "Как курьер проедет по узким улочкам центра?",
          "a": "Наши курьеры доставляют пешком и на скутере, поэтому доезжают даже в пешеходные зоны Виа Сан Чезарео и к Марина Пиккола без задержек."
        },
        {
          "q": "Успеете к отправлению парома на Капри?",
          "a": "Да, если укажете время парома — привезём букет к причалу Марина Пиккола заранее, чтобы вы не спешили."
        },
        {
          "q": "Сколько стоит доставка в центр?",
          "a": "Доставка в центр бесплатна при заказе букета от €99; сам букет — тоже от €99."
        }
      ]
    },
    "en": {
      "seoText": "### Flower Delivery in Sorrento Centre\n\nSorrento's centre revolves around Piazza Tasso, from which Via San Cesareo runs off lined with limoncello and marquetry shops. From here it's a short walk to the terraces of Villa Comunale overlooking the Bay of Naples and to the Marina Piccola pier where ferries leave for Capri.\n\nWe deliver bouquets to the old town's boutique hotels and restaurants, to the pier and the panoramic terraces. Our courier knows the maze of narrow central lanes, so the flowers arrive fresh and on time — even at the height of the tourist season.\n\n**Popular orders:** roses for a dinner overlooking the bay, in-room bouquets at the Grand Hotel Excelsior Vittoria, a surprise for the Capri ferry.\n\n[Bouquet catalog](/sorrento?lang=en) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Can you deliver a bouquet to a dinner on Piazza Tasso?",
          "a": "Yes, we bring flowers right to the table or hand them to the maître d' before you arrive — popular for anniversaries and proposals in Sorrento centre."
        },
        {
          "q": "Can you leave the bouquet at a hotel reception in the old town?",
          "a": "Of course. At the Grand Hotel Excelsior Vittoria, Antiche Mura and other central hotels the concierge accepts the bouquet, and we coordinate the hand-over."
        },
        {
          "q": "How does the courier navigate the narrow central lanes?",
          "a": "Our couriers deliver on foot and by scooter, so they reach even the pedestrian zones of Via San Cesareo and Marina Piccola without delay."
        },
        {
          "q": "Can you make it before the Capri ferry departs?",
          "a": "Yes, if you give us the ferry time we bring the bouquet to the Marina Piccola pier ahead of schedule so you're not rushed."
        },
        {
          "q": "How much is delivery to the centre?",
          "a": "Delivery to the centre is free with a bouquet from €99; bouquets themselves also start at €99."
        }
      ]
    }
  },
  "sant-agnello": {
    "ru": {
      "seoText": "### Доставка цветов в Сант-Аньелло\n\nСант-Аньелло — тихий сосед Сорренто, где старинные виллы прячутся в садах, а Grand Hotel Cocumella и Parco dei Principi хранят атмосферу гранд-тура XIX века. Отсюда открываются спокойные виды на Везувий, а до центра Сорренто — десять минут пешком вдоль моря.\n\nМы часто возим сюда цветы в резиденции и отели: букет к завтраку на террасе, композицию к годовщине, сюрприз в номер с видом на залив. Спокойные улицы Сант-Аньелло позволяют доставлять быстро и бережно.\n\n**Что заказывают:** розы и гортензии в Parco dei Principi, букеты на виллы Колли ди Фонтанелле.\n\n[Каталог букетов](/sorrento) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Доставляете в Grand Hotel Cocumella и Parco dei Principi?",
          "a": "Да, это одни из самых частых адресов в Сант-Аньелло — букет передаём консьержу и, для сюрприза, согласуем время вручения на террасе или в номере."
        },
        {
          "q": "Можно привезти цветы на виллу в Колли ди Фонтанелле?",
          "a": "Да, доставляем на виллы и в резиденции района; для адресов на холмах уточним подъезд и удобное время."
        },
        {
          "q": "Успеете к завтраку на террасе отеля?",
          "a": "Да, при заказе накануне или рано утром привезём свежий букет к завтраку — красивое начало дня с видом на Везувий."
        },
        {
          "q": "Чем Сант-Аньелло удобен для доставки?",
          "a": "Спокойные улицы и отсутствие туристической толчеи центра позволяют доставлять быстро и аккуратно, не повредив букет."
        },
        {
          "q": "Букеты от какой суммы?",
          "a": "От €99, с бесплатной доставкой по Сант-Аньелло при заказе букета от этой суммы."
        }
      ]
    },
    "en": {
      "seoText": "### Flower Delivery in Sant'Agnello\n\nSant'Agnello is Sorrento's quiet neighbour, where historic villas hide in gardens and the Grand Hotel Cocumella and Parco dei Principi keep the atmosphere of the 19th-century Grand Tour. It offers calm views of Vesuvius, and Sorrento centre is a ten-minute walk along the sea.\n\nWe often bring flowers here to residences and hotels: a bouquet for breakfast on the terrace, an arrangement for an anniversary, a surprise in a room overlooking the bay. Sant'Agnello's quiet streets let us deliver quickly and with care.\n\n**Popular orders:** roses and hydrangeas at Parco dei Principi, bouquets to the villas of Colli di Fontanelle.\n\n[Bouquet catalog](/sorrento?lang=en) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Do you deliver to the Grand Hotel Cocumella and Parco dei Principi?",
          "a": "Yes, these are among the most frequent addresses in Sant'Agnello — we hand the bouquet to the concierge and, for a surprise, time the hand-over on the terrace or in the room."
        },
        {
          "q": "Can you bring flowers to a villa in Colli di Fontanelle?",
          "a": "Yes, we deliver to the area's villas and residences; for hillside addresses we confirm access and a convenient time."
        },
        {
          "q": "Can you make it in time for breakfast on the hotel terrace?",
          "a": "Yes, ordering the evening before or early morning, we bring a fresh bouquet for breakfast — a beautiful start to the day with a view of Vesuvius."
        },
        {
          "q": "Why is Sant'Agnello convenient for delivery?",
          "a": "Quiet streets and none of the centre's tourist crowds let us deliver quickly and carefully, without damaging the bouquet."
        },
        {
          "q": "What's the minimum bouquet price?",
          "a": "From €99, with free delivery across Sant'Agnello when ordering a bouquet from that amount."
        }
      ]
    }
  },
  "piano-di-sorrento": {
    "ru": {
      "seoText": "### Доставка цветов в Пьяно-ди-Сорренто\n\nПьяно-ди-Сорренто — живой городок полуострова с настоящей местной жизнью: рынок, семейные траттории и старинная гавань Марина ди Кассано, куда рыбаки возвращаются с уловом. Здесь меньше туристов и больше атмосферы повседневной Италии.\n\nМы доставляем букеты в дома и апартаменты, к причалу Марина ди Кассано и в отели вроде Grand Hotel Vesuvio. Удобно заказать цветы родным, друзьям или к семейному празднику.\n\n**Что заказывают:** букеты на новоселье и дни рождения, цветы к гавани Марина ди Кассано.\n\n[Каталог букетов](/sorrento) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Доставляете к гавани Марина ди Кассано?",
          "a": "Да, привозим цветы к старой рыбацкой гавани и на лодки — атмосферное место для сюрприза у воды."
        },
        {
          "q": "Можно заказать букет местным жителям, а не туристам?",
          "a": "Да, многие заказывают цветы родным и друзьям, живущим в Пьяно-ди-Сорренто — доставим на дом или в апартаменты."
        },
        {
          "q": "Доставляете в Grand Hotel Vesuvio?",
          "a": "Да, возим в отели района; букет передаём на ресепшен и согласуем удобное время."
        },
        {
          "q": "Успеете доставить в день заказа?",
          "a": "Обычно да — Пьяно-ди-Сорренто рядом с центром, поэтому доставка занимает немного времени после подтверждения."
        },
        {
          "q": "Какая минимальная цена?",
          "a": "Букеты от €99, доставка по Пьяно-ди-Сорренто бесплатна при заказе от этой суммы."
        }
      ]
    },
    "en": {
      "seoText": "### Flower Delivery in Piano di Sorrento\n\nPiano di Sorrento is a lively peninsula town with genuine local life: a market, family trattorias and the old Marina di Cassano harbour where fishermen return with the catch. There are fewer tourists here and more of the atmosphere of everyday Italy.\n\nWe deliver bouquets to homes and apartments, to the Marina di Cassano pier and to hotels such as the Grand Hotel Vesuvio. A convenient way to send flowers to family, friends or for a family celebration.\n\n**Popular orders:** housewarming and birthday bouquets, flowers to the Marina di Cassano harbour.\n\n[Bouquet catalog](/sorrento?lang=en) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Do you deliver to the Marina di Cassano harbour?",
          "a": "Yes, we bring flowers to the old fishing harbour and onto boats — an atmospheric spot for a surprise by the water."
        },
        {
          "q": "Can I order a bouquet for locals rather than tourists?",
          "a": "Yes, many people send flowers to family and friends living in Piano di Sorrento — we deliver to homes or apartments."
        },
        {
          "q": "Do you deliver to the Grand Hotel Vesuvio?",
          "a": "Yes, we deliver to the area's hotels; we hand the bouquet to reception and agree a convenient time."
        },
        {
          "q": "Can you deliver on the same day?",
          "a": "Usually yes — Piano di Sorrento is close to the centre, so delivery takes little time after confirmation."
        },
        {
          "q": "What is the minimum price?",
          "a": "Bouquets from €99, with free delivery across Piano di Sorrento when ordering from that amount."
        }
      ]
    }
  },
  "massa-lubrense": {
    "ru": {
      "seoText": "### Доставка цветов в Масса-Лубренсе\n\nМасса-Лубренсе — зелёный край на самом кончике полуострова, между Неаполитанским и Салернским заливами. Оливковые рощи, крошечная гавань Марина делла Лобра, деревня Сант-Агата-суи-Дуэ-Гольфи и заповедный мыс Пунта Кампанелла с видом на Капри — здесь тихо, красиво и по-настоящему уединённо.\n\nМы доставляем букеты на виллы, в бутик-отели вроде Relais Blu и на панорамные площадки. Для удалённых адресов на холмах советуем заказывать заранее.\n\n**Что заказывают:** цветы на виллы с видом на Капри, букеты для романтического ужина в Сант-Агате.\n\n[Каталог букетов](/sorrento) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Доставляете на виллы с видом на Капри?",
          "a": "Да, это популярное направление — привозим букеты на виллы Масса-Лубренсе и Сант-Агаты; для адресов на холмах уточним подъезд."
        },
        {
          "q": "Сколько времени идёт доставка сюда?",
          "a": "Чуть дольше, чем в центр Сорренто, из-за извилистых дорог полуострова. В сезон лучше заказать за день, чтобы выбрать удобное время."
        },
        {
          "q": "Доставите к ресторану в Сант-Агате-суи-Дуэ-Гольфи?",
          "a": "Да, привозим цветы к ресторанам и отелям деревни — красиво для романтического ужина между двумя заливами."
        },
        {
          "q": "Можно доставить к Марина делла Лобра или на лодку?",
          "a": "Да, доставляем к маленькой гавани и на лодки — атмосферный вариант для сюрприза у моря."
        },
        {
          "q": "Есть ли надбавка за удалённые адреса?",
          "a": "Для дальних вилл возможна небольшая надбавка — уточним при оформлении. Букеты — от €99."
        }
      ]
    },
    "en": {
      "seoText": "### Flower Delivery in Massa Lubrense\n\nMassa Lubrense is a green corner at the very tip of the peninsula, between the Gulfs of Naples and Salerno. Olive groves, the tiny Marina della Lobra harbour, the village of Sant'Agata sui Due Golfi and the protected Punta Campanella cape facing Capri — it's quiet, beautiful and genuinely secluded.\n\nWe deliver bouquets to villas, to boutique hotels such as Relais Blu and to panoramic viewpoints. For remote hillside addresses we recommend ordering in advance.\n\n**Popular orders:** flowers to villas overlooking Capri, bouquets for a romantic dinner in Sant'Agata.\n\n[Bouquet catalog](/sorrento?lang=en) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Do you deliver to villas overlooking Capri?",
          "a": "Yes, it's a popular destination — we bring bouquets to villas in Massa Lubrense and Sant'Agata; for hillside addresses we confirm access."
        },
        {
          "q": "How long does delivery here take?",
          "a": "A little longer than to Sorrento centre, because of the peninsula's winding roads. In season it's best to order a day ahead to pick a convenient time."
        },
        {
          "q": "Can you deliver to a restaurant in Sant'Agata sui Due Golfi?",
          "a": "Yes, we bring flowers to the village's restaurants and hotels — lovely for a romantic dinner between the two gulfs."
        },
        {
          "q": "Can you deliver to Marina della Lobra or onto a boat?",
          "a": "Yes, we deliver to the little harbour and onto boats — an atmospheric option for a surprise by the sea."
        },
        {
          "q": "Is there a surcharge for remote addresses?",
          "a": "For distant villas a small surcharge may apply — we confirm on ordering. Bouquets start from €99."
        }
      ]
    }
  },
  "marina-grande": {
    "ru": {
      "seoText": "### Доставка цветов в Марина-Гранде\n\nМарина-Гранде — старинная рыбацкая деревня Сорренто с разноцветными домиками у самой воды, лодками на берегу и рыбными тавернами прямо на пирсе. Это самое атмосферное место побережья: сюда спускаются по лестнице от центра, чтобы поужинать у моря на закате.\n\nМы доставляем букеты к тавернам на воде, на пляжные площадки и к лодкам. Идеально для романтического ужина, предложения руки и сердца или фотосессии в декорациях старой Италии.\n\n**Что заказывают:** букеты к ужину в Delfino, цветы к закату на пирсе, сюрприз на лодке.\n\n[Каталог букетов](/sorrento) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Доставите букет к ужину в рыбной таверне на пирсе?",
          "a": "Да, привозим цветы к столу в тавернах Марина-Гранде, например в Delfino — эффектно для романтического ужина у воды на закате."
        },
        {
          "q": "Можно устроить сюрприз с цветами на лодке?",
          "a": "Да, доставляем букеты на лодки и к причалу деревни — красивый вариант для предложения руки и сердца."
        },
        {
          "q": "Как курьер спускается в деревню?",
          "a": "К Марина-Гранде ведёт лестница и узкая дорога; наши курьеры доставляют пешком, поэтому доносят букет прямо к воде."
        },
        {
          "q": "Подходит ли место для фотосессии с букетом?",
          "a": "Да, разноцветные домики и лодки — популярный фон; поможем с букетом и подскажем удачное время по свету."
        },
        {
          "q": "Букеты от какой цены?",
          "a": "От €99, доставка в Марина-Гранде бесплатна при заказе букета от этой суммы."
        }
      ]
    },
    "en": {
      "seoText": "### Flower Delivery in Marina Grande\n\nMarina Grande is Sorrento's old fishing village, with colourful houses right by the water, boats on the shore and fish taverns on the pier itself. It's the most atmospheric spot on the coast: people walk down the steps from the centre to dine by the sea at sunset.\n\nWe deliver bouquets to the waterside taverns, to the beach spots and to boats. Perfect for a romantic dinner, a marriage proposal or a photoshoot in the setting of old Italy.\n\n**Popular orders:** bouquets for dinner at Delfino, flowers for sunset on the pier, a surprise on a boat.\n\n[Bouquet catalog](/sorrento?lang=en) · [WhatsApp](https://wa.me/905316224378)",
      "faq": [
        {
          "q": "Can you deliver a bouquet to dinner at a fish tavern on the pier?",
          "a": "Yes, we bring flowers to the table at Marina Grande's taverns, for example Delfino — striking for a romantic dinner by the water at sunset."
        },
        {
          "q": "Can you arrange a flower surprise on a boat?",
          "a": "Yes, we deliver bouquets onto boats and to the village pier — a beautiful option for a marriage proposal."
        },
        {
          "q": "How does the courier get down to the village?",
          "a": "Marina Grande is reached by steps and a narrow lane; our couriers deliver on foot, so they bring the bouquet right to the water."
        },
        {
          "q": "Is it a good spot for a photoshoot with a bouquet?",
          "a": "Yes, the colourful houses and boats are a popular backdrop; we'll help with the bouquet and suggest a good time for the light."
        },
        {
          "q": "What's the starting price for bouquets?",
          "a": "From €99, with free delivery to Marina Grande when ordering a bouquet from that amount."
        }
      ]
    }
  }
};
